import { AbstractControl } from '@angular/forms';

import { namePatterns } from '@com-delta-idp/mnx-utils';
import { nameConfig, regexList } from './regex-list';

// eslint-disable-next-line complexity
export function UsernameSkyMilesNumberEmailValidator(
  control: AbstractControl
): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value?.match(regexList.userIdLength)) {
    if (value.match(regexList.skyMilesNumber)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    } else if (
      value.match(regexList.userName) &&
      value.match(regexList.isNaN)
    ) {
      return <{ [s: string]: boolean }>(<unknown>null);
    } else if (value.match(regexList.email)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
  }
  return { INVALID_SKYMILES_NUMBER: true };
}

export function SkyMilesNumberValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value?.match(regexList.userIdLength)) {
    if (value.match(regexList.skyMilesNumber)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
  }
  return { INVALID_SKYMILES_NUMBER: true };
}

export function nameRegex(value: string | undefined, key: string) {
  if (nameConfig.nameLengthConfig) {
    return value?.match(namePatterns[key]);
  } else {
    return (
      value?.match(regexList[key + 'Length']) && value.match(regexList[key])
    );
  }
}

export function FirstNameValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value && nameRegex(value, 'firstName')) {
    return <{ [s: string]: boolean }>(<unknown>null);
  }
  return { FIRSTNAME_NO_MATCH: true };
}

export function LastNameValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value && nameRegex(value, 'lastName')) {
    return <{ [s: string]: boolean }>(<unknown>null);
  }
  return { INVALID_LASTNAME: true };
}
